"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ErrorMessageContainer = void 0;
var _formik = require("formik");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Label = require("../primitive/Label");
/**
 *
 * ErrorMessage component can be used to display an error in (most often) forms. An optional name prop can be given to
 * make use of Formiks dynamic errormessage.
 */
var ErrorMessage = function ErrorMessage(_ref) {
  var name = _ref.name,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(ErrorMessageContainer, {
    "data-cy": "errorMessage"
  }, name ? /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
    name: name
  }) : children);
};
var _default = exports["default"] = ErrorMessage;
var ErrorMessageContainer = exports.ErrorMessageContainer = (0, _styledComponents["default"])(_Label.Label).withConfig({
  displayName: "ErrorMessage__ErrorMessageContainer",
  componentId: "sc-oxc3w6-0"
})(["margin-left:3px;margin-bottom:3px;margin-top:9px;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.negative['60'];
});
//# sourceMappingURL=ErrorMessage.js.map